<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import DxButton from 'devextreme-vue/button';
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import Loader from "../components/loader";
import CustomStore from 'devextreme/data/custom_store';
import api from "@/axios";

import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxStateStoring,
  DxGroupPanel, DxGrouping, DxFilterRow,
  DxRemoteOperations, DxPager
} from 'devextreme-vue/data-grid';
import moment from "moment";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  components: {
    Layout,
    PageHeader,
    DxButton,
    DxDataGrid,
    DxColumn,
    DxColumnChooser,
    DxColumnFixing,
    DxSelection,
    DxExport,
    DxStateStoring,
    DxGroupPanel,
    DxGrouping,
    DxFilterRow,
    DxToolbar,
    DxItem,
    DxRemoteOperations,
    DxPager,
    Loader
  },
  data() {
    return {
      title: "Tracking Monitoramento's",
      items: [
        {
          text: "Administrativo",
          href: "/"
        },
        {
          text: "ApuTracking Monitoramento",
          active: true
        }
      ],
      dataList: null,
      totalList: 0,
      movList: null,
      totalMov: 0,
      updating: false,
      

      dtIniFiltro: null,
      dtFimFiltro: null,
      submittedPeriodo: false,
      showModalPeriodo: false,

      tipoAgrupamentos:  [
        { id: 'transportador', text: 'Transportador' },
        { id: 'estado', text: 'Estado' },
        { id: 'cidade', text: 'Cidade' },
      ],
      tipoAgrup: 'estado'
    };
  },

  computed: {
    dataGrid: function() {
      return this.$refs.dataGridRefKey.instance
    },
    dataGridSecundario: function() {
      return this.$refs.dataGridSecundarioRefKey.instance
    }
  },

  mounted() {
    console.log('mounted mov-list_0')
    this.atualizaDataList()
    this.atualizaMovList()
  },

  methods: {
    confirmarPeriodo(){
      console.log('confirmarPeriodo')

      localStorage.setItem('filtros', JSON.stringify({
        'movdi': moment(this.dtIniFiltro).format('YYYY-MM-DD'),
        'movdf': moment(this.dtFimFiltro).format('YYYY-MM-DD'),
      }))

      this.showModalPeriodo = false
      this.atualizaDataList()
      this.atualizaMovList()
    },

    carregouGrid(){
      console.log('carregouGrid')
      const dtIniFormated = moment(this.dtIniFiltro).format('DD/MM/YYYY')
      const dtFimFormated = moment(this.dtFimFiltro).format('DD/MM/YYYY')
      this.title = `Rastreamento: ${dtIniFormated} - ${dtFimFormated}`
    },

    atualizaDataList(){
      console.log('atualizaDataList_mov')

      const filtros = JSON.parse(localStorage.getItem("filtros"))
      console.log('filtros')
      console.log(filtros)
      if (!filtros) {
        console.log('cookie dataMov não existe, criando')
        console.log('sem filtro')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
        localStorage.setItem('filtros', JSON.stringify({
          'movdi': perIniPadrao,
          'movdf': perFimPadrao,
        }))
      } else {
        this.dtIniFiltro = filtros['movdi']
        this.dtFimFiltro = filtros['movdf']
      }

      if (!this.dtIniFiltro && !this.dtFimFiltro){
        console.log('sem filtro')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
      }

      const di = this.dtIniFiltro
      const df = this.dtFimFiltro

      this.dataList = new CustomStore({
        key: 'transportadorid',
        load: function(){
          const paramsReq = {
            'di': di,
            'df': df
          }

          console.log('paramsReq')
          console.log(paramsReq)

          return api.get(`${getBaseUrl()}api/trackmonitora`, {
            params: paramsReq
          }).then(response => {
            console.log('response.data')
            console.log(response)

            return {
              data: response.data['data'],
              totalCount: response.data['totalCount'],
            }
          })
        },
      })

    },

    atualizaMovList(){
      console.log('atualizaMovList')

      const filtros = JSON.parse(localStorage.getItem("filtros"))
      console.log('filtros')
      console.log(filtros)
      if (!filtros) {
        console.log('cookie dataMov não existe, criando')
        console.log('sem filtro')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
        localStorage.setItem('filtros', JSON.stringify({
          'movdi': perIniPadrao,
          'movdf': perFimPadrao,
        }))
      } else {
        this.dtIniFiltro = filtros['movdi']
        this.dtFimFiltro = filtros['movdf']
      }

      if (!this.dtIniFiltro && !this.dtFimFiltro){
        console.log('sem filtro')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
      }

      const di = this.dtIniFiltro
      const df = this.dtFimFiltro

      this.movList = new CustomStore({
        key: 'movid',
        load: function(){
          const paramsReq = {
            'di': di,
            'df': df
          }

          console.log('paramsReq lasttrackeds')
          console.log(paramsReq)

          return api.get(`${getBaseUrl()}api/lasttrackeds`, {
            params: paramsReq
          }).then(response => {
            console.log('response.data lasttrackeds')
            console.log(response)

            return {
              data: response.data['data'],
              totalCount: response.data['totalCount'],
            }
          })
        },
      })
    },

    onRowDblClick(row) {
      console.log('onRowDblClick')
      let idData = row.key
      console.log(idData)
    },

    onRowDblClickSecundario(row) {
      console.log('onRowDblClickSecundario')
      let idData = row.key
      console.log(idData)
    },

    onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "mov_status") {
          const valStatus = e.data.mov_status
          let corStatus = 'rgba(78,59,0,0.5)'
          switch (valStatus) {
            case 'EL':
              corStatus = 'rgba(78,59,0,0.5)'
              break
            case 'CF':
              corStatus = 'rgba(0,58,78,0.5)'
              break
            case 'ENP':
              corStatus = 'rgba(33,78,0,0.5)'
              break
            case 'ECR':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'EAT':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'NED':
              corStatus = 'rgba(146,73,0,0.5)'
              break
            case 'NEF':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'SCT':
              corStatus = 'rgba(146,111,0,0.5)'
              break
            case 'CCT':
              corStatus = 'rgba(0,58,78,0.5)'
              break
          }
          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;

        } else if (e.column.dataField === "diasentrega") {
          const valDias = e.data.diasentrega
          let corDias = null
          if (!valDias) {
            corDias = null
          } else if (valDias < 0) {
            corDias = 'rgba(146,20,0,0.5)'
          } else if (valDias > 0) {
            corDias = 'rgba(33,78,0,0.5)'
          }
          e.cellElement.style.cssText = `color: white; background-color: ${corDias}`;
        }
      }
    },

    onCellPreparedSecundario(e) {
      // Reutilize a lógica ou crie uma específica para o segundo grid
      this.onCellPrepared(e)
    },

    onExporting(e){
      console.log('onExporting')
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), this.title + '.xlsx');
        });
      });
      e.cancel = true;
    },

    onExportingSecundario(e){
      console.log('onExportingSecundario')
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'notas-rastreadas.xlsx');
        });
      });
      e.cancel = true;
    },

    refeFormTable(){
      console.log('refeFormTable')
      this.dataGrid.state(null);
      this.dataGridSecundario.state(null);
    },

    formatDecimal(value) {
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    formatInteger(value) {
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    },

    nomeStatus(e) {
      switch (e.value) {
        case 'EL':
          return 'Elaboração(EL)'
        case 'PR':
          return 'Ordem Saída'
        case 'OS':
          return 'Ordem Saída'
        case 'CF':
          return 'Pedido Conferido (CF)'
        case 'NEM':
          return 'Nota Fiscal Emitida (NEM)'
        case 'NLO':
          return 'Não Encontrado (NLO)'
        case 'ENP':
          return 'Entregue no Prazo (ENP)'
        case 'ECR':
          return 'Entregue com Ressalva (ECR)'
        case 'EAT':
          return 'Entregue com Atraso (EAT)'
        case 'CCT':
          return 'Com CTe (CCT)'
      }
      return e.value
    },

    openDeparo(){
      console.log('openDeparo')
      this.$router.push({ path: '/tracking/depara' });
    },
  },

};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items"  @click="showModalPeriodo = true"/>

    <div>
      <DxToolbar>
        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="refresh"
              hint="Redefinir formatação de tabela para padrão"
              :on-click="refeFormTable"/>
        </DxItem>

        <DxItem
          location="before"
          widget="dxButton"
        >
          <DxButton
            icon="warning"
            text="Deparos"
            :on-click="openDeparo"
            styling-mode="contained"
            type="success"
            style="background-color: #ff9800; border-color: #ff9800; font-weight: 500;"
          />
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
        </DxItem>

        <DxItem
            location="after"
            widget="dxButton">
        </DxItem>
      </DxToolbar>
    </div>

    <Loader v-if="updating" style="min-height: 300px;">
    </Loader>

    <div class="mt-2" v-if="!updating">
      <div class="row" style="margin-right: -5px; margin-left: -5px;">
        <div class="col-lg-6" style="padding: 5px;">
          <div style="overflow-x: auto; padding: 10px; border: 1px solid #ddd; border-radius: 4px; height: 100%;">
            <h5 class="mb-3">Transportadoras Com Rastreio Ativo</h5>
            <DxDataGrid
              ref="dataGridRefKey"
              :data-source="dataList"
              :show-borders="true"
              :focused-row-enabled="true"
              :column-auto-width="true"
              :show-row-lines="true"
              :allow-column-reordering="true"
              :allow-column-resizing="true"
              :row-alternation-enabled="true"
              @cell-prepared="onCellPrepared"
              @row-dbl-click="onRowDblClick"
              @content-ready="carregouGrid"
              @exporting="onExporting">

            <DxRemoteOperations
                :filtering="false"
                :paging="false"
                :sorting="false"
                :summary="false"
                :grouping="false"
                :group-paging="false"
            />

            <DxColumnChooser :enabled="true"/>
            <DxColumnFixing :enabled="true"/>
            <DxFilterRow :visible="true" />
            <DxSelection mode="multiple"/>
            <DxExport
                :enabled="true"
                :allow-export-selected-data="true"/>
            <DxStateStoring
                :enabled="true"
                type="sessionStorage"
                storage-key="strMovCteListApuracao"/>

            <DxGroupPanel :visible="true"/>
            <DxGrouping />

            <DxColumn
                data-field="transportadorid"
                fixed-position="left"
                caption="id"
                alignment="left"
                data-type="number"
                :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                :allowHeaderFiltering="false"/>

            <DxColumn
                data-field="transportador"
                fixed-position="left"
                caption="Transportador"
                alignment="left"
                data-type="text"
                :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                :allowHeaderFiltering="false"/>

            <DxColumn
                data-field="cnpj"
                fixed-position="left"
                caption="Transp. CNPJ"
                alignment="left"
                data-type="text"
                :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                :allowHeaderFiltering="false"/>

            <DxColumn
                data-field="apirastreio"
                fixed-position="left"
                caption="API tracking"
                alignment="left"
                data-type="text"
                :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                :allowHeaderFiltering="false"/>

            <DxColumn data-field="contagem"
                      caption="Total Notas"
                      alignment="right"
                      data-type="number"
                      :format="formatInteger"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false">
            </DxColumn>

            <DxColumn data-field="rastreadas"
                      caption="Notas Rastreadas"
                      alignment="right"
                      data-type="number"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false">
            </DxColumn>

            <DxColumn data-field="nao_rastreadas"
                      caption="Notas Sem Rastreio"
                      alignment="right"
                      data-type="number"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false">
            </DxColumn>

            <DxColumn data-field="naofinalizadas"
                      caption="Não Finalizadas"
                      alignment="right"
                      data-type="number"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false">
            </DxColumn>

            <DxPager
                :visible="true"
                :show-page-size-selector="true"
                :allowed-page-sizes="[10, 30, 50, 100]"
                :show-navigation-buttons="true"
                :show-info="true"/>

            </DxDataGrid>
          </div>
        </div>

        <div class="col-lg-6" style="padding: 5px;">
          <div style="overflow-x: auto; padding: 10px; border: 1px solid #ddd; border-radius: 4px; height: 100%;">
            <div class="d-flex justify-content-between">
              <h5 class="mb-3">Ultimas Notas Rastreadas</h5>
              <!-- <span>teste</span> -->
            </div>
          <DxDataGrid
              ref="dataGridSecundarioRefKey"
              :data-source="movList"
              :show-borders="true"
              :focused-row-enabled="true"
              :column-auto-width="true"
              :show-row-lines="true"
              :allow-column-reordering="true"
              :allow-column-resizing="true"
              :row-alternation-enabled="true"
              @cell-prepared="onCellPreparedSecundario"
              @row-dbl-click="onRowDblClickSecundario"
              @content-ready="carregouGridSecundario"
              @exporting="onExportingSecundario">

            <DxRemoteOperations
                :filtering="false"
                :paging="false"
                :sorting="false"
                :summary="false"
                :grouping="false"
                :group-paging="false"
            />

            <DxColumnChooser :enabled="true"/>
            <DxColumnFixing :enabled="true"/>
            <DxFilterRow :visible="true" />
            <DxSelection mode="multiple"/>
            <DxExport
                :enabled="true"
                :allow-export-selected-data="true"/>
            <DxStateStoring
                :enabled="true"
                type="sessionStorage"
                storage-key="strMovCteListApuracaoSecundario"/>

            <DxGroupPanel :visible="true"/>
            <DxGrouping />

            <DxColumn
                data-field="movid"
                fixed-position="left"
                caption="ID"
                alignment="left"
                data-type="number"
                :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                :allowHeaderFiltering="false"/>

            <DxColumn
                data-field="codigo"
                fixed-position="left"
                caption="NF"
                alignment="left"
                data-type="text"
                :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                :allowHeaderFiltering="false"/>

            <DxColumn
                data-field="stsentr"
                fixed-position="left"
                caption="Hub"
                alignment="left"
                data-type="text"
                :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                :allowHeaderFiltering="false"/>

            <DxColumn data-field="tracked_at"
                      caption="Último Rastreamento"
                      alignment="center"
                      data-type="timestamp"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false">
            </DxColumn>

            <DxColumn
                data-field="transportador"
                fixed-position="left"
                caption="Transportador"
                alignment="left"
                data-type="text"
                :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                :allowHeaderFiltering="false"/>

            <DxColumn
                data-field="cnpj"
                caption="Transp. CNPJ"
                alignment="left"
                data-type="text"
                :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                :allowHeaderFiltering="false"/>

            <DxColumn
                data-field="movstatus"
                caption="Status"
                alignment="left"
                data-type="text"
                :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                :allowHeaderFiltering="false"/>

            <DxColumn
                data-field="obsentr"
                caption="Obs. Entrega"
                alignment="left"
                data-type="text"
                :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                :allowHeaderFiltering="false"/>

            <DxPager
                :visible="true"
                :show-page-size-selector="true"
                :allowed-page-sizes="[10, 30, 50, 100]"
                :show-navigation-buttons="true"
                :show-info="true"/>

          </DxDataGrid>
          </div>
        </div>
      </div>
    </div>

    <b-modal title="Período de Exibição" v-model="showModalPeriodo" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="tipooperacao">Selecionar Data Inicial e Final</label>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtIniFiltro">Data Início</label>
            <input
                id="dtIniFiltro"
                v-model="dtIniFiltro"
                type="date"
                class="form-control"
                placeholder="Data Início"
                :class="{'is-invalid': submittedPeriodo && !dtIniFiltro,}"/>
            <div v-if="submittedPeriodo && !dtIniFiltro"
                 class="invalid-feedback">
              <span >Campo data início obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtFimFiltro">Data Final</label>
            <input
                id="dtFimFiltro"
                v-model="dtFimFiltro"
                type="date"
                class="form-control"
                placeholder="Data Final"
                :class="{'is-invalid': submittedPeriodo && !dtFimFiltro,}"/>
            <div v-if="submittedPeriodo && !dtFimFiltro"
                 class="invalid-feedback">
              <span >Campo data final obrigatória, favor preencher.</span>
            </div>
          </div>
        </div>
      </div>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalPeriodo = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confirmarPeriodo">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>

  </Layout>
</template>
